import {createParagraphIn, setElementInnerHTML} from '../../ui_utils/DomUtils'
import {ItemData, UIComponentItemPanelCell} from './UIComponentItemPanelCell'
import {UIComponentItemPanelGrid} from './UIComponentItemPanelGrid'
import {clientI18n} from '../../ClientI18n'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export class UIComponentItemPanel {
    private readonly container: HTMLDivElement
    private readonly selectedItemImageContainer: HTMLDivElement
    private readonly selectedItemNameContainer: HTMLDivElement
    private readonly selectedItemInfoIcon: HTMLImageElement

    private selectedItem: UIComponentItemPanelCell
    private readonly itemGrid: UIComponentItemPanelGrid

    constructor(container: HTMLDivElement, itemData: ItemData[]) {
        this.container = container.querySelector('.item-panel') as HTMLDivElement
        this.selectedItemImageContainer = container.querySelector('.selected-item-image-container') as HTMLDivElement
        this.selectedItemNameContainer = container.querySelector('.selected-item-title-container') as HTMLDivElement
        this.selectedItemInfoIcon = container.querySelector('.selected-item-info-icon') as HTMLImageElement
        this.itemGrid = new UIComponentItemPanelGrid(this.container)
        if(UIUtilsEjsVariables.isUserOnDiscord) this.container.classList.add(('discord'))
        this.generateItems(itemData)
    }

    update(itemData: ItemData[]) {
        this.clear()
        this.generateItems(itemData)
        this.itemGrid.update()
    }

    updateInteractabilityOfElements(isGuest: boolean) {
        this.itemGrid.updateInteractabilityOfElements(isGuest)
    }

    resetItemGridToTop() {
        this.itemGrid.resetToTop()
    }

    private generateItems(itemData: ItemData[]) {
        itemData.forEach((item: ItemData) => {
            this.itemGrid.addItem(item)
            if(item.selected) this.setSelectedItem(item)
        })
    }

    private setSelectedItem(itemData: ItemData) {
        this.selectedItem = new UIComponentItemPanelCell(this.selectedItemImageContainer, itemData)
        const name = createParagraphIn(this.selectedItemNameContainer, itemData.name, 'selected-item-title')
        if(itemData.infoAction) {
            this.selectedItemImageContainer.onclick = itemData.infoAction
            this.selectedItemInfoIcon.onclick = itemData.infoAction
        }
        this.selectedItem.removeTooltip()

        const charLimitLargeFont = 20
        const itemName = clientI18n.t(itemData.name.key, itemData.name.options)
        if(itemName.length > charLimitLargeFont) name.style.fontSize = '.75rem'
    }

    private clear() {
        setElementInnerHTML(this.selectedItemImageContainer, {key: 'strings:colonistCommon.utils.emptyString'})
        setElementInnerHTML(this.selectedItemNameContainer, {key: 'strings:colonistCommon.utils.emptyString'})
        this.itemGrid.clear()
    }
}
